import React, { Component } from 'react';
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

class Banner extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tabbannerlist: [],
        }
    }

    componentDidMount() {
        instance.get("/api/v1/tabbannerlist?System=" + Systems + "")
            .then((res) => {
                if (res.data.status === 200) {
                    this.setState({
                        tabbannerlist: res.data.message
                    });
                }
            });
    }

    render() {
        const { tabbannerlist } = this.state;

        const desktopShow = this.props.slidesToShow || 1;
        const mt = this.props.marginTop !== undefined ? this.props.marginTop : '-40px';
        const settings = {
            dots: true,
            dotsClass: 'slick-dots',
            infinite: true,
            speed: 500,
            slidesToShow: desktopShow,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        dots: true,
                    }
                }
            ]
        };

        if (tabbannerlist.length === 0) return null;

        return (
            <div className="x-banner-slide-wrapper -single" style={{ position: 'relative', paddingBottom: '8px', marginTop: mt }}>
                <style>{`
                    .x-banner-slide-wrapper .slick-prev,
                    .x-banner-slide-wrapper .slick-next {
                        z-index: 10;
                        width: 38px;
                        height: 38px;
                        background: rgba(0,0,0,0.6) !important;
                        border-radius: 50%;
                    }
                    .x-banner-slide-wrapper .slick-prev { left: 8px; }
                    .x-banner-slide-wrapper .slick-next { right: 8px; }
                    .x-banner-slide-wrapper .slick-prev:before,
                    .x-banner-slide-wrapper .slick-next:before {
                        font-size: 22px;
                        color: #EFD0A0;
                        opacity: 1;
                        line-height: 38px;
                    }
                    .x-banner-slide-wrapper .slick-dots {
                        bottom: 4px;
                    }
                    .x-banner-slide-wrapper .slick-dots li button:before {
                        color: #EFD0A0;
                        font-size: 10px;
                        opacity: 0.5;
                    }
                    .x-banner-slide-wrapper .slick-dots li.slick-active button:before {
                        opacity: 1;
                        color: #EFD0A0;
                    }
                `}</style>
                <Slider {...settings}>
                    {tabbannerlist.map((item, index) => (
                        <div key={index}>
                            <a
                                className="-link-wrapper"
                                href={item.url || '/promotion'}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (this.props.checkurl) {
                                        this.props.checkurl(e, item.url || '/promotion');
                                    } else {
                                        window.location.href = item.url || '/promotion';
                                    }
                                }}
                                style={{ margin: "0px 8px", display: "block", cursor: "pointer" }}
                            >
                                <img
                                    className="img-fluid -cover"
                                    src={item.path}
                                    alt={item.alt || `banner${index + 1}`}
                                    style={{ width: "100%", borderRadius: "15px" }}
                                />
                            </a>
                        </div>
                    ))}
                </Slider>
            </div>
        );
    }
}

export default Banner;
